import moment from 'moment';

export function sortCompareDate(order) {
    return (a, b) => {
        const amo = moment(a.data, 'M/D/YY');
        const bmo = moment(b.data, 'M/D/YY');
        return amo.diff(bmo, 'day') * (order === 'asc' ? 1 : -1);
    }
}
